import { render } from "./fldScript.vue?vue&type=template&id=d2065bf2"
import script from "./fldScript.vue?vue&type=script&lang=js"
export * from "./fldScript.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__